import { Component, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CampaignService } from '../campaign.service';
import { Campaign } from '../campaign.model';

import { SharedDataService } from '../../shared/data.service';
import { StatisticService } from '../../statistics/statistic.service';

declare var $: any;

@Component({
  selector: 'wm-campaign-statistic',
  template: require('./campaign-statistic.component.html')
})
export class CampaignStatisticComponent implements OnChanges {
  @Input() campaign: Campaign;

  public requests: Array<any>;
  public statsumm = {};

  loading = true;

  constructor(
    private service: CampaignService,
    private statistic: StatisticService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (!!this.campaign) {
      if (this.campaign.counters.length > 0 || this.campaign.links.length > 0) {
        let ids = {links: [], counters: []};
        let total = {};

        this.campaign.counters.forEach(function(item, index) {
          ids.counters.push(item['id']);

          if (!!item['total']) {
            total[item['id']] = item['total'];
          }
        });

        this.campaign.links.forEach(function(item, index) {
          ids.links.push(item['id']);
        });

        this.getStatistic(ids, total);
      }

      this.loading = false;
    }
  }

  listCountUpdate(items) {
    Object.keys(items).forEach(metric => {
      if (!this.statsumm[metric]) {
        this.statsumm[metric] = {};
      }

      Object.keys(items[metric]).forEach(item => {
        if (!this.statsumm[metric][item]) {
          this.statsumm[metric][item] = 0;
        }

        Object.keys(items[metric][item]).forEach(oid => {
         this.statsumm[metric][item] += items[metric][item][oid];
        });
      });
    });

    this.statsumm['ctr'] = '-';
    this.statsumm['cr'] = '-';

    if (!!this.statsumm['links'] && !!this.statsumm['counters'] &&
      !!this.statsumm['links']['users'] && !!this.statsumm['counters']['users']) {
      this.statsumm['ctr'] = (
        Number(this.statsumm['links']['users']) / Number(this.statsumm['counters']['users']) * 100
      ).toFixed(2) + '%';
    };

    if (!!this.statsumm['links'] && !!this.statsumm['links']['payments'] && !!this.statsumm['links']['clicks']) {
      this.statsumm['cr'] = (
        Number(this.statsumm['links']['payments']) / Number(this.statsumm['links']['clicks']) * 100
      ).toFixed(2) + '%';
    };

  }

  getStatistic(statistic_ids, total = {}) {
    let prepared = [];

    if (statistic_ids['links'].length > 0) {
      prepared.push({
        ids: statistic_ids['links'], metrics: ['clicks', 'users'], hidden: ['users'],
        start_date: this.campaign['created_at'], end_date: this.campaign['end_date'],
        statistic_type: 'links'
      });

      this.campaign.agents.forEach(item => {
        let agent = {shop_id: item['shop_id'], purse_id: item['purse_id']};

        prepared.push({
          ids: statistic_ids['links'], metrics: ['payments'], filters: [{agent: agent}],
          start_date: this.campaign['created_at'], end_date: this.campaign['end_date'],
          statistic_type: 'links', position: 'right'
        });
      });
    }

    if (statistic_ids['counters'].length > 0) {
      prepared.push({
        ids: statistic_ids['counters'], metrics: ['views', 'sessions', 'users'], hidden: ['sessions'],
        start_date: this.campaign['created_at'], end_date: this.campaign['end_date'],
        total: total, statistic_type: 'counters'
      });
    }

    this.requests = prepared;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/campaigns/components/campaign-statistic.component.ts